export default {
  'objectStorage.list.title': '對象存儲',
  'objectStorage.list.columns.title1': '名稱',
  'objectStorage.list.columns.title2': '平臺',
  'objectStorage.list.columns.title3': '區域代號（Region）',
  'objectStorage.list.columns.title4': '操作',
  'objectStorage.list.top.title1': '第三方對象存儲',
  'objectStorage.list.top.text1': '授權接入，即刻使用',
  'objectStorage.list.top.title2': 'LightCDN對象存儲',
  'objectStorage.list.top.text2': '自由搭建，完全掌控',
  'objectStorage.list.top.btnText1': '授權接入',
  'objectStorage.list.top.btnText2': '上線提醒我',
  'objectStorage.list.top.btnText3': '已設置提醒',
  'objectStorage.list.Popconfirm.okText': '是的',
  'objectStorage.list.Popconfirm.cancelText': '取消',
  'objectStorage.list.Popconfirm.cdnText': '前往cdn資源',
  'objectStorage.list.Popconfirm.delText.1': '確認刪除 ',
  'objectStorage.list.Popconfirm.delText.2': ' 的對象存儲嗎？',
  'objectStorage.list.Popconfirm.delNoText.1': '當前還有 ',
  'objectStorage.list.Popconfirm.delNoText.2': ' 個資源使用 ',
  'objectStorage.list.Popconfirm.delNoText.3': '作爲源，請更換源後再進行刪除',
  'objectStorage.create.btnText': '授權對象存儲',
  'objectStorage.create.form.name': '名稱',
  'objectStorage.create.form.name.label':
    '（創建時，用於平臺區別的空間名稱，非第三方的對象存儲名稱）',
  'objectStorage.create.form.name.message': '請輸入正確的名字',
  'objectStorage.create.form.name.rule': '請使用 4-20 字符',
  'objectStorage.create.form.name.placeholder': '請選擇已接入的對象存儲',
  'objectStorage.create.form.PleaseInput': '請輸入',
  'objectStorage.create.form.PleaseSelect': '請選擇',
  'objectStorage.create.form.thirdPartyName': '第三方平臺',
  'objectStorage.create.form.secretKeyAK': '密鑰ID （AK）',
  'objectStorage.create.form.secretKeyAK.message': '請輸入正確的密鑰ID （AK）',
  'objectStorage.create.form.secretKeySK': '密鑰Key （SK）',
  'objectStorage.create.form.secretKeySK.message': '請輸入正確的密鑰Key （SK）',
  'objectStorage.create.form.secretKeySK.placeholder': '需要重新驗證',
  'objectStorage.create.form.regionCode': '區域代號（Region）',
  'objectStorage.create.form.regionCode.placeholder': '例：us-east-2',
  'objectStorage.create.form.regionCode.message': '請輸入正確的區域代號',
  'objectStorage.create.form.Endpoint': 'Endpoint（選填）',
  'objectStorage.create.form.Endpoint.placeholder': 'Endpoint域名或URL，只有非AWS應用時才需要填寫',
  'objectStorage.create.form.EndpointStyle': 'Endpoint中存儲桶訪問樣式',
  'objectStorage.create.form.access': '獲取方式',
  'objectStorage.create.form.StorageSpaceName': '存儲空間名稱',
  'objectStorage.create.form.StorageSpaceName.placeholder': '例：oss-cn-shanghai.aliyuncs.com',
  'objectStorage.create.form.StorageSpaceName.message': '請輸入正確的存儲空間名稱',
  'objectStorage.create.form.access.tip1': '訪問URL：CDNhostname/path/filename',
  'objectStorage.create.form.access.tip2':
    '訪問URL：CDNhostname/BUCKET-NAME/path/filename。若你的文件直接存儲在對象存儲中，可能不存在path。',
  'objectStorage.create.form.document': '點擊此處瞭解如何接入 →',
  'objectStorage.create.form.bucketAddressStyle.1': '路徑',
  'objectStorage.create.form.bucketAddressStyle.2': '子域名',
  'objectStorage.create.form.bucketParam.1': '指定存儲空間',
  'objectStorage.create.form.bucketParam.2': 'URL前綴/BUCKET-NAME/filename',
  'objectStorage.create.form.name.unique': '名稱已存在。',
};
